import { useMutation, useQueryClient } from '@tanstack/react-query';
import { omit } from 'lodash';

import { DeclarationGoods } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface HookProps {
  updatedGoodItems: DeclarationGoods[];
  declarationId: string;
  aiModuleMustRunAfterSave?: boolean;
  newPriceSaved?: number;
  storeSavedDeclaration: boolean;
}

export const saveGoodsItems = async ({ updatedGoodItems, declarationId, aiModuleMustRunAfterSave, newPriceSaved, storeSavedDeclaration = true }: HookProps) => {
  const goodItems = updatedGoodItems.map((goodItem) => {
    return omit(goodItem, ['commodityCode', 'dutiesAndTaxes', 'webScraping']) as DeclarationGoods;
  });

  const result = await apiClient.declarationsCrud.saveMultipleGoodItems.mutation({
    params: { id: declarationId },
    body: { goodItems, aiModuleMustRunAfterSave, newPriceSaved },
  });
  if (result.status !== 200) throw result.body;
  return result.body.data;
};

export const useSaveGoodsItems = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: saveGoodsItems,
    onSuccess: (_, variables) => {
      if (variables.storeSavedDeclaration) {
        queryClient.invalidateQueries({ queryKey: ['declaration', variables.declarationId] });
      }
    },
    onError: (error) => {
      showErrorToast(error, `Error saving goods items!`);
    },
  });
};
